module.exports = __webpack_public_path__ + "static/media/Agro-dealer infographic desktop 22-01-2024 C (1).ccfdc318.gif";